import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { api } from '@mf/common/config/axios/serviceApi';
import { TFeatureFlagResponse } from './types';

export type TAxiosDefaultConfig = {
  baseUrl?: string;
  token?: string;
};

const strapiFeatureFlags = ({ baseUrl, token }: TAxiosDefaultConfig) => {
  const apiCms: AxiosInstance = api({ baseUrl, token });

  const getFeatureFlags = async (): Promise<TFeatureFlagResponse> => {
    const { data }: { data: TFeatureFlagResponse } = await apiCms.get(
      '/v1/feature-flags',
      {
        headers: {
          'Cache-Control': 'no-cache',
        },
      },
    );

    return data;
  };

  const useFeatureFlags = () => {
    return useQuery(['feature-flags'], () => getFeatureFlags());
  };

  return {
    getFeatureFlags,
    useFeatureFlags,
  };
};

export default strapiFeatureFlags;
